// Casanova Barbier — Centralized Media Library
// Organized chronologically. Drop new batches in as they arrive.
// Each year has: videos[], images[] (ordered by date when possible)

const mediaLibrary = {
  2020: {
    videos: [
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/wrr5l5ri_IMG_0023.MOV',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/zrsfiuos_IMG_0024.MOV',
    ],
    images: [
      // IMG_0188 — founders + Pasqualino with the first red chairs (user pick as opening image)
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/lno4tx19_IMG_0188.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/kta784rw_62880903489__94F7FAE5-423A-4427-B539-96AA5FCE8851.HEIC',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/curgz3ie_IMG_0172.HEIC',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/ttpt56rf_IMG_0224.HEIC',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/3n4sfyd4_IMG_0344.JPG',
    ],
  },
  2021: {
    videos: [
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/0x7rb4ok_1.mp4',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/38upf73m_7.mp4',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/j85p30pt_8.mp4',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/flg3w0zw_9.mp4',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/6tlo140t_11.mp4',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/9du16zvx_12.mp4',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/9rgdjmna_2021.mp4',
      // 2021-07-11 — Euro final: Italy wins, hosted at the shop
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/5v3is6iw_20210711_175616.mp4',
    ],
    images: [
      // 2021-02-21 studio session
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/ievatb9l_20210221-DSC07687.jpg',
      // 2021-03-25 editorial session
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/vs7sqclv_20210325-DSC07936.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/6rwi3nq6_20210325-DSC07940.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/g52ui8a9_20210325-DSC07942.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/zk3qfg2i_20210325-DSC07943.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/mqhfirad_20210325-DSC07948.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/6b5wgt3r_20210325-DSC07950.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/de59zep0_20210325-DSC07961.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/kabyd51s_20210325-DSC07966.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/7h0mcgyn_20210325-DSC07968.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/i7c6cg9x_20210325-DSC07969.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/92xxux59_20210325-DSC07971.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/85xtn1ip_20210325-DSC07974.jpg',
      // 2021 — early editorial portraits (pre-renovation shop)
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/q76vxiq8_DSC07497.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/yjx9kd1l_DSC07500.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/ua1tksud_DSC07515.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/p15911rn_DSC07518.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/eoud49i1_DSC07532.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/7s67b7ag_DSC07570.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/aesv66oj_DSC07586.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/muq75ygl_DSC07594.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/qm4a8rc2_DSC07601.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/427fyez5_DSC07627.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/5grnn3eb_DSC07632.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/b7njop2t_DSC07639.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/guw2863y_DSC07679.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/82sih5is_DSC07682.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/besfr74b_DSC07685.jpg',
    ],
  },
  // Future years will be added here chronologically:
  2022: {
    videos: [
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/gqxk45s9_2022.mp4',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/x54as0j2_CASANOVA%20-%20May%203.mp4',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/r6riclu0_CHERRY.mp4',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/buigx5q5_CLIENT%201.mp4',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/2a9enlsk_CLIENT%202.mp4',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/h4jqmcqe_PASC%20-.mp4',
    ],
    images: [
      // Team portraits — shop after Italian-heritage styling refresh
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/fr8lx6vn_IMG_3789.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/tc42n3pw_IMG_3790.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/omp6zoc2_IMG_3806.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/6javgm0z_IMG_3808.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/34h58olc_IMG_3843.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/rx5s2p8p_IMG_3856.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/9b56bo8u_IMG_3859.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/42r0334a_IMG_3861.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/ldtwl80e_IMG_3874.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/1699rxz2_IMG_3875.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/etn32wnq_IMG_3876.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/wq8v7g0s_IMG_3877.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/ur9sjkaj_IMG_3878.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/rmikfr8k_IMG_3888.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/mujij7b0_IMG_3892.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/n5awkz30_IMG_3895.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/v7fecwcu_IMG_3899.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/f3mc6cia_IMG_3901.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/j3pf562t_IMG_3904.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/mtidxias_IMG_3907.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/b5hm8i35_IMG_3914.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/t8svanrc_IMG_3915.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/mf76s4ai_IMG_3916.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/udz6t9vj_IMG_3919.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/0hvykso3_IMG_3901.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/2wkysafw_IMG_3908.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/7l3z7l17_IMG_3909.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/ypw9fun6_IMG_3910.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/0f7z0o30_IMG_3914.jpg',
    ],
  },
  // 2023
  2023: {
    videos: [
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/egq7mnon_2023.mp4',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/flf7nl4z_JDB%20-%201.mp4',
    ],
    images: [
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/ivyve42h_DSC01414.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/ohjq4m9s_DSC01420.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/h6ocjc7y_DSC01428.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/jq8ozmyn_DSC01439.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/83e0hkqj_DSC01444.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/qlmtp1su_DSC01454.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/3rdkrtbh_DSC01461.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/dmgqjbr0_DSC01468.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/blhnpvod_DSC01480.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/7f7726mv_DSC01492.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/69td7ujg_DSC01493.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/ne0qwf7w_DSC01506.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/guv4j1jw_DSC01519.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/4v7jyg0i_DSC01522.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/p43ehvq7_DSC01523.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/fr2cig0j_DSC01545.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/qunlhdk7_DSC01546.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/ixjg67re_DSC01547.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/l4dm376v_DSC01548.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/xcc52kt1_DSC01567.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/1twdfm08_DSC01569.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/m60seonk_DSC01570.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/f9efp9if_DSC01580.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/4iar8d3w_DSC01579.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/2sapzl6d_DSC01597.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/5qy1ivb9_DSC01600.JPG',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/w4hpfvtm_DSC01601.jpg',
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/tqq57505_DSC01608.JPG',
    ],
  },
  // 2024
  2024: {
    videos: [
      'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/3xhl1cr9_2024.mp4',
    ],
    images: [],
  },
};

// Convenience flat accessors
export const allVideos = Object.values(mediaLibrary).flatMap((y) => y.videos);
export const allImages = Object.values(mediaLibrary).flatMap((y) => y.images);

// Curated "hero" picks used across the site (stable references)
export const FEATURED = {
  // Main hero video — 2023 cinematic shop clip
  heroVideo: 'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/egq7mnon_2023.mp4',
  // Poster shown instantly while heroVideo loads — DSC01428 (mirror straight-razor),
  // visually consistent with the cinematic clip.
  heroPoster: 'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/h6ocjc7y_DSC01428.JPG',
  // Story section secondary video
  storyVideo: mediaLibrary[2021].videos[1],
  // Service page rotation (indexed by service)
  serviceVideos: mediaLibrary[2021].videos,
  // A strong editorial still (wash chair, DSC07687) for image-led sections
  editorialStill: mediaLibrary[2021].images[0],
  // Storefront — 56 Jean-Talon Ouest, Little Italy (editorial illustration, used on Home)
  storefront: 'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/71jl4dyh_ChatGPT%20Image%20Apr%2022%2C%202026%2C%2007_52_48%20PM.png',
  // Storefront photograph — real shopfront, used on Contact page
  contactStorefront: 'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/ba1hjsqe_164480.png',
  // Per-team-member video posters — show instantly while video downloads
  pasqualinoPoster:
    'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/gzcnumql_164791.png',
  // Francesco poster — uses an existing 2023 still (well-lit interior shot)
  francescoPoster:
    'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/4v7jyg0i_DSC01522.JPG',
  // Cherry team-card poster — re-uses one of the 2023 stills
  cherryPoster:
    'https://customer-assets.emergentagent.com/job_italian-grooming/artifacts/dmgqjbr0_DSC01468.JPG',
};

// Optimized image URL via the weserv.nl proxy. Used for posters so the still
// loads in <100ms regardless of original file size.
export const optimizeImg = (url, width = 1280, quality = 80) => {
  const stripped = (url || '').replace(/^https?:\/\//, '');
  return `https://images.weserv.nl/?url=${encodeURIComponent(stripped)}&w=${width}&output=webp&q=${quality}&we`;
};

export default mediaLibrary;
